import React from "react";
import "./DocumentViewer.scss";

/**
 * Renders one study guide in an iframe pointed at the authenticated API route.
 *
 * The iframe keeps each guide's own CSS and scripts from colliding with the
 * portfolio's styles, and because the request is same-origin the session cookie
 * rides along automatically — an anonymous request to the same URL gets a 401.
 * localStorage keeps working, so the progress ticks in each guide still save.
 */
export default function DocumentViewer({document, isDark, onClose}) {
  const source =
    `/api/learning?collection=${encodeURIComponent(document.collection)}` +
    `&file=${encodeURIComponent(document.file)}`;

  return (
    <div className={isDark ? "doc-viewer dark-mode" : "doc-viewer"}>
      <div className="doc-viewer-bar">
        <button type="button" className="doc-viewer-back" onClick={onClose}>
          &larr; All documents
        </button>
        <span className="doc-viewer-title" title={document.file}>
          {document.title}
        </span>
        <a
          className="doc-viewer-open"
          href={source}
          target="_blank"
          rel="noopener noreferrer"
        >
          Open in new tab
        </a>
      </div>
      <iframe
        className="doc-viewer-frame"
        src={source}
        title={document.title}
      />
    </div>
  );
}
